module.exports = __webpack_public_path__ + "static/media/Inter-Bold.100b5c82.woff";